import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'
import { ForgotPasswordForm } from '../schemas/ForgotPasswordSchema'

async function recoveryPassword({ email }: ForgotPasswordForm) {
  return api.backend.post('/user/forgot-password', { email })
}

export function useRecoveryPassword() {
  const { t } = useTranslation('login')
  const { mutateAsync, isPending, isSuccess, isError } = useMutation<
    unknown,
    AxiosError<ApiError>,
    ForgotPasswordForm
  >({
    mutationKey: ['/user/forgot-password'],
    mutationFn: recoveryPassword,
    onSuccess: () => {
      toast(Toast, {
        toastId: 'recovery-success',
        data: {
          type: 'success',
          icon: Mail,
          title: t('forgot_password.toast.success.title'),
          description: t('forgot_password.toast.success.message'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        toastId: 'recovery-error',
        data: {
          type: 'danger',
          icon: Mail,
          title: t('forgot_password.toast.error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('forgot_password.toast.error.message'),
        },
      })
    },
  })

  const handleRecoveryPassword = async (email: string) => {
    await mutateAsync({ email })
  }

  return {
    handleRecoveryPassword,
    isPendingRecoveryPassword: isPending,
    isSuccessRecoveryPassword: isSuccess,
    isErrorRecoveryPassword: isError,
  }
}
